import one from '../assets/svg/projects/img1.png'
import two from '../assets/svg/projects/img2.png'
import three from '../assets/svg/projects/img3.png'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Visual & Marketing',
        projectDesc: 'Developed a dynamic website for photography, videography, and digital marketing services, featuring engaging animations and responsive design. ',
        tags: ['Javascript', 'CSS', 'GSAP'],
        code: 'https://github.com/Mrutyunjaya-Sahoo/visionary-blend',
        demo: 'https://mrutyunjaya-sahoo.github.io/visionary-blend/src',
        image: one
    },
    {
        id: 2,
        projectName: 'E-commerce',
        projectDesc: 'User-friendly restaurant e-commerce platform where customers could browse food options and manage their orders with ease. ',
        tags: ['React JS', 'Tailwind CSS'],
        code: '#',
        demo: 'https://whiff-point.netlify.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Email Validator',
        projectDesc: 'Developed a web-based tool to validate email authenticity, ensuring a smooth user experience.',
        tags: ['Javascript', 'CSS'],
        code: 'https://github.com/MrutyunjayaSahoo/Email-Validator',
        demo: 'https://mrutyunjayasahoo.github.io/Email-Validator/',
        image: three
    },
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/